import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ILayoutMinimalAbstract } from 'shared-types/SharedTypes';
import DateUtilsService from 'external-services/date-utils-service';
import LayoutsService from 'external-services/layouts-service/layouts.service';
import { IActiveLayoutsState } from './types';
import { BookingCreatorState } from 'booking-creator/rootReducer';
import { errorStateActions, getAccordionDetail } from 'app/reducers/errorState/slice';
import { CONTACT_MSG, PROBLEMS_MSG, REFRESH_MSG } from 'appRoot/app-error-messages';

const NS = 'activeLayoutsSlice';

const initialState: IActiveLayoutsState = {
  layouts: [],
};

export const setLayoutsForActiveService = createAsyncThunk(
  'activeLayouts/setLayoutsForActiveService',
  async (payload: void, { dispatch, getState }): Promise<ILayoutMinimalAbstract[]> => {
    const {
      displayReducer: { activeBooking, selectedService },
    } = getState() as BookingCreatorState;

    let bookingDate: Date = activeBooking.time;
    const isValidDate = DateUtilsService.isValidDate(bookingDate);

    if (!isValidDate) return [];

    bookingDate = DateUtilsService.getClearDate(bookingDate, null);

    const layoutIds: string[] = selectedService.sectionLayouts.map((sl) => sl.layoutId);

    try {
      const layouts = await LayoutsService.getLayouts(layoutIds, bookingDate);
      return layouts;
    } catch (err) {
      console.warn(
        NS,
        `Error on 'getServiceLayoutsByDate' getting layouts. selectedService, date: `,
        selectedService,
        bookingDate,
        err
      );
      dispatch(
        errorStateActions.setErrorState({
          errorTitle: 'Problem loading service layouts',
          errorMessage: `There was a problem getting service layouts. \n\n${PROBLEMS_MSG} ${REFRESH_MSG} \n\n${CONTACT_MSG}`,
          accordionDetail: getAccordionDetail(err),
        })
      );
      return [];
    }
  }
);

const activeLayoutsSlice = createSlice({
  name: 'activeLayouts', // used in action types
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setLayoutsForActiveService.fulfilled, (state, action) => {
      // console.log(NS, 'action.payload', action.payload)
      state.layouts = action.payload;
    });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = activeLayoutsSlice;
// Extract and export each action creator by name
export { actions as activeLayoutsActions };
// Export the reducer, either as a default or named export
export default reducer;
